namespace TabAurous.OMS {
    export namespace ProductBOMService {
        export const baseUrl = 'OMS/ProductBOM';

        export declare function Create(request: Serenity.SaveRequest<ProductBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductBOM(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProductBOM/Create",
            Update = "OMS/ProductBOM/Update",
            Delete = "OMS/ProductBOM/Delete",
            Retrieve = "OMS/ProductBOM/Retrieve",
            GetProductBOM = "OMS/ProductBOM/GetProductBOM",
            List = "OMS/ProductBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetProductBOM', 
            'List'
        ].forEach(x => {
            (<any>ProductBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
